import { type Control, type RegisterOptions } from 'react-hook-form'

import { FormRadioGroupDS } from 'components/reusable/form/FormFields'
import { TextLink } from 'slab'
import { type MemberOnboardingMember } from 'utils/web_api.schemas'

import { LABEL_CONTAINER_CLASSES } from './RenewalsMemberInfoEditForm/RenewalsMemberInfoEditForm'

export function NewYorkOrganDonorQuestionField ({ control, fieldId, memberInfo, missingFields, rules }: {
  control?: Control<any>,
  fieldId?: string,
  memberInfo: MemberOnboardingMember | undefined,
  missingFields: Array<string> | undefined, // TODO: this should really be the full dictionary of missing fields
  rules?: Omit<RegisterOptions<any, any>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>,
}) {
  function shouldShowOrganDonorForm (memberInfo: MemberOnboardingMember, missingFields: Array<string>) {
    return missingFields.includes('ny_organ_donor_opt_in') || memberInfo.ny_opted_in_organ_donor != null
  }
  function serializeOrganDonor (memberInfo: MemberOnboardingMember, missingFields: Array<string>) {
    if (missingFields.includes('ny_organ_donor_opt_in')) {
      return '-'
    }
    return memberInfo.ny_opted_in_organ_donor ? 'Yes' : 'Not yet'
  }

  if (!memberInfo || missingFields == null || !shouldShowOrganDonorForm(memberInfo, missingFields)) {
    return null
  }

  if (!control || !fieldId) {
    return (
      <div>
        <div className={LABEL_CONTAINER_CLASSES}>
          <span>Would you like to be an organ donor?</span>
        </div>
        <div className={LABEL_CONTAINER_CLASSES}>
          <span>{serializeOrganDonor(memberInfo, missingFields)}</span>
        </div>
      </div>
    )
  }

  return (
    <FormRadioGroupDS
      control={control}
      name={fieldId}
      label='Would you like to be an organ donor?'
      options={[
        { label: 'Yes', value: 'yes' },
        { label: 'Not yet', value: 'no' },
      ]}
      layout='horizontal'
      buttonVariant='bordered'
      buttonSize='small'
      rules={rules}
      description={
        <>
          New York lets residents join the free{' '}
          <TextLink
            href='https://donatelife.ny.gov/'
            target='_blank'
            color='purple'
          >
            Donate Life Registry
          </TextLink>{' '}
          when signing up for health insurance
        </>
      }
    />
  )
}
